import { Outlet } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { PageTitle } from './PageTitle';

type LayoutProps = {
  children?: React.ReactNode;
};

const cookies = new Cookies(null, { path: '/' });

export const UnloggedLayout = ({ children }: LayoutProps) => {
  cookies.remove('userId');

  return (
    <div
      style={{
        backgroundImage: `url(/assets/onboarding/bg.png)`,
        backgroundRepeat: 'repeat',
      }}
      className="min-h-screen bg-neutral-700"
    >
      <PageTitle />
      <div
        style={{
          backgroundImage: `url(/assets/waves.png)`,
          backgroundRepeat: 'repeat-x',
          animation: 'wave-animation 20s linear infinite',
        }}
        className="w-full min-h-screen flex flex-col justify-between"
      >
        <div className="flex-grow flex items-center justify-center animate-fade-in-up">
          {children || <Outlet />}
        </div>
      </div>
    </div>
  );
};
